<template>
  <form class="v2-blog-search mb-5" @submit="onSubmit">
    <span class="bg-sticker arrow d-none d-lg-block">
      <img v-lazy="arrowPinkSticker" :alt="`sticker arrow`" />
    </span>
    <span class="bg-sticker fire d-none d-lg-block">
      <img v-lazy="fireSticker" :alt="`sticker fire`" />
    </span>

    <div class="d-flex justify-content-center flex-column flex-sm-row">
      <input
        v-model="currentTitle"
        :placeholder="t('Search')"
        type="text"
        name="search_title"
        class="form-control"
        @input="onChangeTitle"
        @change="onChangeTitle"
      />

      <select class="form-select" name="search_category" @change="onChangeCategory">
        <option value="">
          {{ t("Choose category") }}
        </option>
        <option v-for="item in categories" :key="item.id" :value="item.id" :selected="category === item.id.toString()">
          {{ item[`title_${locale}`] }}
        </option>
      </select>
    </div>
  </form>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import blogService from "@/api/services/blogService";
import { BlogPostCategory } from "@/interfaces/Blog/BlogPostCategory.ts";
import arrowPinkSticker from "@/assets/v2/images/stickers/arrow-pink.svg";
import fireSticker from "@/assets/v2/images/stickers/fire.svg";

defineOptions({
  name: "blog-search-v2",
});

const props = defineProps({
  category: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["onChangeCategory", "onChangeTitle"]);

const { locale, t } = useI18n();
const categories = ref<BlogPostCategory[]>([]);
const currentTitle = ref(props.title);
let delayTimer: number | null = null;

const onSubmit = (e: Event) => {
  e.preventDefault();
};

const onChangeCategory = (e: Event) => {
  const target = e.target as HTMLSelectElement;
  emit("onChangeCategory", target.value);
};

const onChangeTitle = () => {
  clearTimeout(delayTimer as number);
  delayTimer = window.setTimeout(() => {
    emit("onChangeTitle", currentTitle.value);
  }, 500);
};

onMounted(async () => {
  categories.value = await blogService.getCategories(locale.value);
});
</script>

<style lang="scss">
@import "./index";
</style>
